<template>
<div class="pt-2 mt-2">
   
    <v-toolbar flat color="white">
        <v-tabs>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab @click="
            checkedInTab = true;
            checkedOutTab = false;
            movementByContact = false;
            onHand = false;
          " class="grey--text" flat round color="grey">Checked In</v-tab>
            <v-tab @click="
            checkedInTab = false;
            checkedOutTab = true;
            movementByContact = false;
            onHand = false;
          " class="grey--text" flat round color="grey">Checked Out</v-tab>
            <v-tab @click="
            checkedInTab = false;
            checkedOutTab = false;
            movementByContact = true;
            onHand = false;
          " class="grey--text" flat round color="grey">Movement by person</v-tab>
            <v-tab @click="
            checkedInTab = false;
            checkedOutTab = false;
            movementByContact = false;
            onHand = true;
          " class="grey--text" flat round color="grey">On Hand by person</v-tab>
        </v-tabs>
    </v-toolbar>
    <v-card flat>
         <v-toolbar flat color="white" v-if="checkedOutTab||checkedInTab">
        <v-spacer></v-spacer>
        <v-text-field v-if="checkedInTab" v-model="checkinSearch" append-icon="search" label="Search" single-line hide-details max-width="50px" class="pa-3" clearable v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          checkinOffset: $route.query.checkinOffset,
          checkoutOffset: $route.query.checkoutOffset,
          checkinSearch: checkinSearch,
          checkoutSearch: $route.query.checkoutSearch,
          records: $route.query.records
          }})"></v-text-field>
        <v-text-field v-if="checkedOutTab" v-model="checkoutSearch" append-icon="search" label="Search" single-line hide-details max-width="50px" class="pa-3" clearable v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          checkinOffset: $route.query.checkinOffset,
          checkoutOffset: $route.query.checkoutOffset,
          checkinSearch: $route.query.checkinSearch,
          checkoutSearch: checkoutSearch,
          records: $route.query.records
          }})"></v-text-field>
    </v-toolbar>
        <v-card flat v-show="checkedInTab">

            <v-data-table :headers="checkinHeaders" class="elevation-1" :items="checkIns" :rows-per-page-items="[$route.query.records]" :loading="isLoading" item-key="id" disable-initial-sort align-center style="cursor: pointer" hide-actions>
                <template v-slot:items="props">
                    <td>
                        <h3 class="grey--text font-weight-light">

                            <v-icon color="light-green">arrow_drop_up</v-icon>
                            {{ props.item.count }}
                        </h3>
                    </td>

                    <td>
                        <h3 v-if="props.item.deviceMakeModelId != null" class="grey--text font-weight-light">
                            {{ props.item.ponMac }}
                        </h3>
                        <h3 v-else class="grey--text font-weight-light">
                            {{ props.item.stockItem.name }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light" v-if="props.item.stockWarehouse">
                            {{ props.item.stockWarehouse.name }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.contact.name }} {{ props.item.contact.surname }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.createdAt }}
                        </h3>
                    </td>
                </template>
                <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of
                    {{ props.itemsLength }}</template>
            </v-data-table>
            <div class="text-xs-center pt-2 white" :key="$route.query.checkinOffset">
                <v-layout wrap>
                    <v-flex xs12>
                        <v-pagination v-model="checkinPage" :length="Math.ceil(checkinTotalItems / $route.query.records)" :total-visible="7"></v-pagination>
                    </v-flex>
                </v-layout>
            </div>
        </v-card>
        <v-card flat v-show="checkedOutTab">

            <v-data-table :headers="checkoutHeaders" class="elevation-1" :items="checkOuts" :rows-per-page-items="[$route.query.records]" :loading="isLoading" item-key="id" disable-initial-sort align-center style="cursor: pointer" hide-actions>
                <template v-slot:items="props">
                    <td>
                        <h3 class="grey--text font-weight-light">
                            <v-icon color="red">arrow_drop_down</v-icon>
                            {{ props.item.count }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.installedCount }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            <v-icon color="light-green">arrow_drop_up</v-icon>{{ props.item.checkedIn }}
                        </h3>
                    </td>
                    <td>
                        <h3 v-if="props.item.device" class="grey--text font-weight-light">
                            <span v-if="props.item.device.deviceMakeModel">{{ props.item.device.deviceMakeModel.name }}</span> {{ props.item.device.ponMac }}
                        </h3>
                        <h3 v-else-if="props.item.stockItem" class="grey--text font-weight-light">
                            {{ props.item.stockItem.name }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light" v-if="props.item.stockWarehouse">
                            {{ props.item.stockWarehouse.name }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.contact.name }} {{ props.item.contact.surname }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.createdAt }}
                        </h3>
                    </td>
                </template>
                <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of
                    {{ props.itemsLength }}</template>
            </v-data-table>
            <div class="text-xs-center pt-2 white" :key="$route.query.checkoutOffset">
                <v-layout wrap>
                    <v-flex xs12>
                        <v-pagination v-model="checkoutPage" :length="Math.ceil(checkoutTotalItems / $route.query.records)" :total-visible="7"></v-pagination>
                    </v-flex>
                </v-layout>
            </div>
        </v-card>

        <v-card flat v-show="movementByContact">
            <v-toolbar flat color="white">
                <h3 class="title grey--text font-weight-bold pr-4">Movement By:</h3>
                <v-flex xs3>
                    <v-autocomplete clearable hide-no-data flat color="primary" :items="contacts" :item-text="(item) => item.name + ' ' + item.surname" item-value="id" v-model="contactId" v-on:change="groupByItem(contactId)" label="Select Contact">
                    </v-autocomplete>
                </v-flex>
                <v-spacer></v-spacer>
                <v-text-field v-model="searchMovementByPerson" append-icon="search" label="Search" single-line hide-details max-width="50px" class="pa-3" clearable></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-data-table :headers="byPersonHeaders" class="elevation-1" :rows-per-page-items="[25, 50, 100, 250, 500]" :loading="isLoading" :pagination.sync="pagination1" :search="searchMovementByPerson" :items="info" item-key="id" align-center style="cursor: pointer">
                <template v-slot:items="props">
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.name }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light" v-if="props.item.contact">
                            {{ props.item.contact.name }} {{ props.item.contact.surname }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            <v-icon color="red"> arrow_drop_down</v-icon>
                            {{ props.item.checkOutCount }}
                        </h3>
                    </td>
                    <td>
                        <h3 v-if="props.item.checkInCount" class="grey--text font-weight-light">
                            <v-icon color="light-green">arrow_drop_up</v-icon>{{ props.item.checkInCount }}
                        </h3>
                        <h3 v-else class="grey--text font-weight-light">
                            <v-icon color="light-green">arrow_drop_up</v-icon>{{ 0 }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.installedCount }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light" v-if="props.item.onHand > 0">
                            {{ props.item.onHand }}
                        </h3>
                        <h3 v-else class="grey--text font-weight-light">{{ 0 }}</h3>
                    </td>
                </template>
                <template v-slot:pageText="props">
                    Records {{ props.pageStart }} - {{ props.pageStop }} of
                    {{ props.itemsLength }}</template>
            </v-data-table>
        </v-card>
        <v-card flat v-show="onHand">
            <v-toolbar flat color="white">
<v-flex xs3 mx-1>
                    <v-autocomplete ref="testMenu" v-on:blur="$refs['testMenu'].blur()" clearable flat color="primary" :items="contacts" :item-text="(item) => item.name + ' ' + item.surname" item-value="id" v-model="onHandContactId" label="Filter by User">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs3 mx-1>
                    <v-autocomplete  ref="testMenu1" v-on:blur="$refs['testMenu1'].blur()" clearable flat color="primary" :items="deviceMakeModelList" item-text="name" item-value="id" v-model="onHandDeviceMakeModel" label="Filter by Device Model">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs3 mx-1>
                    <v-autocomplete  ref="testMenu2" v-on:blur="$refs['testMenu2'].blur()" clearable flat color="primary" :items="stockItemList" item-text="name" item-value="id" v-model="onHandStockItem" label="Filter by Stock Item">
                    </v-autocomplete>
                </v-flex>
            </v-toolbar>
            <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-text-field v-model="searchOnHand" append-icon="search" label="Search" single-line hide-details max-width="50px" class="pa-3" clearable></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-data-table :headers="onHandHeaders" class="elevation-1" :rows-per-page-items="[25, 50, 100, 250, 500]" :loading="isLoading" :pagination.sync="pagination2"  :items="filterOnHandList" item-key="id" align-center style="cursor: pointer">
                <template v-slot:items="props">
                    <td class="text-xs-center">
                        <v-layout>
                            <v-icon @click="removeStockOnHand(props.item)" class="mx-2" color="red">cancel</v-icon>
                            <v-icon @click="handleStockMovement(props.item)">input</v-icon>
                        </v-layout>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.contact.name}} {{ props.item.contact.surname}}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.count - props.item.checkedIn - props.item.installedCount}}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            <v-icon color="red">arrow_drop_down</v-icon>
                            {{ props.item.count }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.installedCount }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            <v-icon color="light-green">arrow_drop_up</v-icon>{{ props.item.checkedIn }}
                        </h3>
                    </td>
                    <td>
                        <h3 v-if="props.item.device" class="grey--text font-weight-light">
                           <span v-if="props.item.device.deviceMakeModel">{{ props.item.device.deviceMakeModel.name }}</span> {{ props.item.device.ponMac }}
                        </h3>
                        <h3 v-else class="grey--text font-weight-light">
                            {{ props.item.stockItem.name }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light" v-if="props.item.stockWarehouse">
                            {{ props.item.stockWarehouse.name }}
                        </h3>
                    </td>
                    <td>
                        <h3 class="grey--text font-weight-light">
                            {{ props.item.createdAt }}
                        </h3>
                    </td>
                </template>
                <template v-slot:pageText="props">
                    Records {{ props.pageStart }} - {{ props.pageStop }} of
                    {{ props.itemsLength }}</template>
            </v-data-table>
        </v-card>
    </v-card>

    <v-dialog v-model="onHandStockMovementModal" width="750px" persistent>
        <v-card v-if="onHandItem">
            <v-toolbar color="primary">
                <v-toolbar-title style="color: white">
                    <span v-if="onHandItem.device">{{onHandItem.device.deviceMakeModel.deviceMake.name}} {{onHandItem.device.deviceMakeModel.name}}: {{onHandItem.device.ponMac}}</span>
                    <span v-else-if="onHandItem.stockItem">{{onHandItem.stockItem.stockType.name}}: {{onHandItem.stockItem.name}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="white" flat @click="onHandStockMovementModal=false, onHandItem={}">X</v-btn>
            </v-toolbar>
              <v-card-title>
                <h3 class="pa-2">Move to Warehouse</h3>
            </v-card-title>
              <v-card-title>
                Available: <v-chip>{{ onHandItem.count - onHandItem.checkedIn - onHandItem.installedCount}}</v-chip>
            </v-card-title>
            <v-card-text>
                <v-layout wrap justify-center>
                    <v-flex xs6 class="text-xs-center px-1">
                        <v-select v-model="onHandItem.targetWarehouseId" label="Warehouse" item-text="name" item-value="id" :items="stockWarehouses"></v-select>
                    </v-flex>
                    <v-flex xs6 class="text-xs-center px-1">
                        <v-text-field v-if="onHandItem.stockItem" type="number" dense v-model="onHandItem.removeQuantity" label="Quantity"></v-text-field>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn round color="primary" :disabled="!onHandItem.targetWarehouseId||!onHandItem.removeQuantity" @click="submitWarehouseChange()">Submit</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="removeStockOnHandModal" width="750px" persistent>
        <v-card v-if="onHandItem">
            <v-toolbar color="primary">
                <v-toolbar-title style="color: white">
                    <span v-if="onHandItem.device">{{onHandItem.device.deviceMakeModel.deviceMake.name}} {{onHandItem.device.deviceMakeModel.name}}: {{onHandItem.device.ponMac}}</span>
                    <span v-else-if="onHandItem.stockItem">{{onHandItem.stockItem.stockType.name}}: {{onHandItem.stockItem.name}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="white" flat @click="removeStockOnHandModal=false, onHandItem={}">X</v-btn>
            </v-toolbar>
            <v-card-title>
              This action will remove the sepcified quantity from stock on hand, and WILL NOT return it to a warehouse.
            </v-card-title>
            <v-card-text>
              <v-layout wrap justify-center>
                <v-flex xs12>
Available: <v-chip>{{ onHandItem.count - onHandItem.checkedIn - onHandItem.installedCount}}</v-chip>
                </v-flex>
 <v-flex xs6 class="text-xs-center">
                <v-text-field  label="Quantity" type="number" v-model="onHandItem.removeQuantity"></v-text-field>
                 </v-flex>
                 <v-flex xs12 class="text-xs-center">
                        <v-btn round color="primary" :disabled="!onHandItem.removeQuantity" @click="processStockRemoval()">Submit</v-btn>
                    </v-flex>
              </v-layout>
                
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
    data() {
        return {
            onHandList: [],
            onHandContactId: null,
            onHandDeviceMakeModel: null,
            onHandStockItem: null,
            onHand: false,
            checkedInTab: true,
            checkedOutTab: false,
            checkinPage: 1,
            checkinPagination: {},
            checkinSearch: "",
            checkinTotalItems: 0,
            checkoutPage: 1,
            checkoutPagination: {},
            checkoutSearch: "",
            checkoutTotalItems: 0,
            onHandItem: {},
            onHandStockMovementModal: false,
            removeStockOnHandModal: false,
            stockWarehouses: [],
            deviceMakeModelList: [],
            stockItemList: [],
            checkoutHeaders: [{
                    text: "Number of Items",
                    align: "center",
                    value: "count"
                },
                {
                    text: "Installed",
                    align: "center",
                    value: "installedCount"
                },
                {
                    text: "Total Checked Back In",
                    align: "center",
                    value: "checkedIn"
                },
                {
                    text: "Item Name",
                    align: "center",
                    value: "name"
                },
                {
                    text: "Warehouse Name",
                    align: "center",
                    value: "stockWarehouse.name"
                },
                {
                    text: "Contact",
                    align: "center",
                    value: "contact.name",
                },
                {
                    text: "Date",
                    align: "center",
                    value: "updatedAt"
                }
            ],
            checkinHeaders: [{
                    text: "Number of Items",
                    align: "center",
                    value: "count"
                },
                {
                    text: "Item Name",
                    align: "center",
                    value: "name"
                },
                {
                    text: "Warehouse Name",
                    align: "center",
                    value: "stockWarehouse.name"
                },
                {
                    text: "Contact",
                    align: "center",
                    value: "contact.name",
                },
                {
                    text: "Date",
                    align: "center",
                    value: "updatedAt"
                }
            ],
            onHandHeaders: [{
                    text: "Actions",
                    align: "center",
                    value: "actions",
                    sortable: false
                },
                {
                    text: "Contact",
                    align: "center",
                    value: "contact.name",
                },
                {
                    text: "On Hand",
                    align: "center",
                    value: "onHand"
                },
                {
                    text: "Number of Items",
                    align: "center",
                    value: "count"
                },
                {
                    text: "Installed",
                    align: "center",
                    value: "installedCount"
                },
                {
                    text: "Total Checked Back In",
                    align: "center",
                    value: "checkedIn"
                },
                {
                    text: "Item Name",
                    align: "center",
                    value: "stockItem.name"
                },
                {
                    text: "Warehouse Name",
                    align: "center",
                    value: "stockWarehouse.name"
                },
                {
                    text: "Date",
                    align: "center",
                    value: "updatedAt"
                }
            ],
            byPersonHeaders: [{
                    text: "Item Name",
                    align: "center",
                    value: "name"
                },
                {
                    text: "User",
                    align: "center",
                    value: "contact.name"
                },
                {
                    text: "Total Stock Out",
                    align: "center",
                    value: "checkOutCount"
                },
                {
                    text: "Total Stock In",
                    align: "center",
                    value: "checkInCount"
                },
                {
                    text: "Total Installed",
                    align: "center",
                    value: "installedCount"
                },
                {
                    text: "Total On Hand",
                    align: "center",
                    value: "onHand",
                }
            ],
            allMovements: true,
            movementByContact: false,
            loading: false,
            isLoading: false,
            searchMovementByPerson: '',
            searchOnHand: '',
            pagination1: {},
            pagination2: {},
            item: null,
            checkoutItems: [],
            movementItems: [],
            contacts: [],
            contactId: null,
            info: [],
            checkIns: [],
            checkOuts: []
        }
    },
    created() {
        this.fetchContacts()
        this.fetchWarehouses()
        this.getAllStock()
        this.fetchAllOnHand()
        this.$router.push({
            name: this.$route.name,
            query: {
                checkinOffset: "0",
                checkoutOffset: "0",
                records: "15"
            }
        })
    },
    computed: {
        filterOnHandList(){
            let result = this.onHandList
            if(this.onHandContactId){
                result = result.filter(x=>x.contactId == this.onHandContactId)
            }
            if(this.onHandDeviceMakeModel){
                result = result.filter(x=>x.device && x.device.deviceMakeModelId== this.onHandDeviceMakeModel)
            }
            if(this.onHandStockItem){
                result = result.filter(x=>x.stockItemId == this.onHandStockItem)
            }
            if(this.searchOnHand){
                result = result.filter(x=>
                x.contact.name.toLowerCase().includes(this.searchOnHand.toLowerCase())||
                x.contact.name.toLowerCase().includes(this.searchOnHand.toLowerCase()) ||
                (x.stockItem&&x.stockItem.name.toLowerCase().includes(this.searchOnHand.toLowerCase()))||
                (x.device&&x.device.ponMac.toLowerCase().includes(this.searchOnHand.toLowerCase()))                
                )
            }
        return result
        }
    },
    watch: {
        '$route.query.checkinSearch': {
            immediate: true,
            handler(value) {
                this.isLoading = true
                if (this.$route.query.checkinSearch && value != null && value !== 'undefined') {
                    this.checkinPage = 1
                    Api()
                        .get('/checkinItem/movementLog', {
                            params: {
                                search: this.$route.query.checkinSearch,
                                offset: '0',
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.checkIns = response.data.result
                            this.checkinTotalItems = response.data.count
                            this.isLoading = false
                        })
                } else if (this.$route.query.checkinOffset) {
                    Api()
                        .get('/checkinItem/movementLog', {
                            params: {
                                offset: this.$route.query.checkinOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.checkIns = response.data.result
                            this.checkinTotalItems = response.data.count
                            this.isLoading = false
                        })
                }
            }
        },
        '$route.query.checkinOffset': {
            immediate: true,
            handler(value) {
                this.isLoading = true

                if (value !== "" && value != null && this.$route.query.checkinSearch && this.$route.query.checkinSearch != "" && this.$route.query.checkinSearch !== null) {

                    Api()
                        .get('/checkinItem/movementLog', {
                            params: {
                                search: this.$route.query.checkinSearch,
                                offset: this.$route.query.checkinOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.checkIns = response.data.result
                            this.checkinTotalItems = response.data.count
                            this.isLoading = false
                        })
                } else if (value != null) {
                    Api()
                        .get('/checkinItem/movementLog', {
                            params: {
                                offset: this.$route.query.checkinOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.checkIns = response.data.result
                            this.checkinTotalItems = response.data.count
                            this.isLoading = false
                        })
                }
            }
        },
        checkinPage(value) {
            this.checkinPagination.page = this.checkinPage;
            if (value && value != "" && value != this.$route.query.records) {
                if (this.$route.query.checkinSearch) {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            records: this.$route.query.records,
                            checkoutOffset: this.$route.query.checkoutOffset,
                            checkinOffset: (value - 1) * this.$route.query.records,
                            checkoutSearch: this.$route.query.checkoutSearch,
                            checkinSearch: this.$route.query.checkinSearch
                        }
                    });
                } else {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            records: this.$route.query.records,
                            checkoutOffset: this.$route.query.checkoutOffset,
                            checkinOffset: (value - 1) * this.$route.query.records,
                            checkoutSearch: this.$route.query.checkoutSearch
                        }
                    });
                }
            }
        },

        '$route.query.checkoutSearch': {
            immediate: true,
            handler(value) {
                this.isLoading = true
                if (this.$route.query.checkoutSearch && value !== "" && value != null && value !== 'undefined') {
                    this.checkoutPage = 1
                    Api()
                        .get('/checkoutItem/movementLog', {
                            params: {
                                search: this.$route.query.checkoutSearch,
                                offset: '0',
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {

                            this.checkOuts = response.data.result
                            this.checkoutTotalItems = response.data.count
                            this.isLoading = false
                        })
                } else if (this.$route.query.checkoutOffset) {
                    Api()
                        .get('/checkoutItem/movementLog', {
                            params: {
                                offset: this.$route.query.checkoutOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {

                            this.checkOuts = response.data.result
                            this.checkoutTotalItems = response.data.count
                            this.isLoading = false
                        })
                }
            }
        },
        '$route.query.checkoutOffset': {
            immediate: true,
            handler(value) {
                this.isLoading = true
                if (value !== "" && value != null && this.$route.query.checkoutSearch && this.$route.query.checkoutSearch != "" && this.$route.query.checkoutSearch !== null) {

                    Api()
                        .get('/checkoutItem/movementLog', {
                            params: {
                                search: this.$route.query.checkoutSearch,
                                offset: this.$route.query.checkoutOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.checkOuts = response.data.result
                            this.checkoutTotalItems = response.data.count
                            this.isLoading = false
                        })
                } else if (value != null) {
                    Api()
                        .get('/checkoutItem/movementLog', {
                            params: {
                                offset: this.$route.query.checkoutOffset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.checkOuts = response.data.result
                            this.checkoutTotalItems = response.data.count
                            this.isLoading = false
                        })
                }
            }
        },
        checkoutPage(value) {

            this.checkoutPagination.page = this.checkoutPage;
            if (value && value != "" && value != this.$route.query.records) {
                if (this.$route.query.checkoutSearch) {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            records: this.$route.query.records,
                            checkoutOffset: (value - 1) * this.$route.query.records,
                            checkinOffset: this.$route.query.checkinOffset,
                            checkoutSearch: this.$route.query.checkoutSearch,
                            checkinSearch: this.$route.query.checkinSearch
                        }
                    });
                } else {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            records: this.$route.query.records,
                            checkoutOffset: (value - 1) * this.$route.query.records,
                            checkinOffset: this.$route.query.checkinOffset,
                            checkinSearch: this.$route.query.checkinSearch
                        }
                    });
                }
            }
        },

    },
    methods: {
        handleStockMovement(item) {
            this.onHandItem = item
            this.onHandStockMovementModal = true
        },
        removeStockOnHand(item) {
            this.onHandItem = item
            this.removeStockOnHandModal = true
        },
        async submitWarehouseChange(){
          var obj = {checkoutItemId: this.onHandItem.id, count: parseInt(this.onHandItem.removeQuantity), stockWarehouseId: this.onHandItem.targetWarehouseId};
           if(this.onHandItem.stockItem){
             obj.stockItemId = this.onHandItem.stockItemId
           } else if(this.onHandItem.device){
             obj.stockItemId = this.onHandItem.deviceId
             }
           await Api().post('/mobile/checkinItems', {batch: [obj]})
           const updateObj = {id: this.onHandItem.id, checkedIn: (this.onHandItem.checkedIn += parseInt(this.onHandItem.removeQuantity))};
           await Api().put('/mobile/checkoutItem/'+updateObj.id, updateObj)
           this.onHandStockMovementModal = false
           this.onHandItem = {}
           this.fetchOnHand(this.onHandContactId)
        },
        async processStockRemoval(){
          const updateObj = {id: this.onHandItem.id, count: (this.onHandItem.count -= parseInt(this.onHandItem.removeQuantity))};
           await Api().put('/mobile/checkoutItem/'+updateObj.id, updateObj)
           this.removeStockOnHandModal = false
           this.onHandItem = {}
           this.fetchOnHand(this.onHandContactId)
        },
        fetchWarehouses() {
            Api().get('/stockwarehouse').then(res => {
                this.stockWarehouses = res.data
            })
        },
        fetchOnHand(contact) {
            Api().get('/checkoutItem/onHand/' + contact).then(response => {
                this.onHandList = response.data
            })
        },
        fetchAllOnHand() {
            Api().get('/checkoutItem/allonHand' ).then(response => {
                this.onHandList = response.data
                let uniqueStockItems = this.onHandList.filter(x=>x.stockItem).map(x=>x.stockItemId)
                let allStockItems = []

                for(let i =0;i<uniqueStockItems.length;i++){
                    let find = this.onHandList.find(x=>x.stockItemId == uniqueStockItems[i])
                    allStockItems.push(find.stockItem)
                }

                let uniqueDeviceModels = this.onHandList.filter(x=>x.device).map(x=>x.device.deviceMakeModelId)
let allDeviceModels = []
                for(let i =0;i<uniqueDeviceModels.length;i++){
                    let find = this.onHandList.find(x=>x.device && x.device.deviceMakeModelId == uniqueDeviceModels[i])
                    allDeviceModels.push(find.device.deviceMakeModel)
                }
                this.deviceMakeModelList = allDeviceModels
                this.stockItemList = allStockItems
                console.log()


            })
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "dd/mm/yyyy HH:MM");
            } else {
                null;
            }
        },
        formatMonth(date) {
            if (date !== null) {
                return dateformat(date, "mm/yyyy");
            } else {
                null;
            }
        },
        checkContact(contactId) {
            if (typeof (contactId) != 'undefined') {
                this.showDevice = true
                this.showStockItem = true
            } else {
                this.showDevice = false
                this.showStockItem = false
            }
        },
        async getStock(contact) {
            var movementItems = []
            await Api()
                .get('/checkoutItem/byPerson/' + contact)
                .then(response => {
                    this.checkoutItems = response.data
                    movementItems = response.data
                    movementItems.forEach(function (element) {
                        element.type = "checkout";
                        if (element.deviceMakeModelId != null) {
                            element.name = element.ponMac
                        } else {
                            element.name = element.stockItem.name
                        }
                    })
                })
            await Api()
                .get('/checkinItem/byPerson/' + contact)
                .then(response => {
                    response.data.map(y => {
                        y.type = 'checkin'
                        if (y.deviceMakeModelId != null) {
                            y.name = y.ponMac
                        } else {
                            y.name = y.stockItem.name
                        }
                        movementItems.push(y)
                    })
                })
            let array = movementItems.sort((a, b) => (a.updatedAt > b.updatedAt) ? 1 : ((a.updatedAt < b.updatedAt) ? -1 : 0));
            this.movementItems = array
            await this.movementItems.map(x => {
                x.updatedAt = this.formatDate(x.updatedAt)
            })
            await this.movementItems.map(async x => {
                if (x.deviceMakeModelId != null) {
                    x.name = x.ponMac
                } else {
                    x.name = x.stockItem.name
                }
            })
            var helper = {}
            var result = this.movementItems.reduce(function (r, o) {
                var key = o.name;
                if (!helper[key]) {
                    helper[key] = Object.assign({}, o);
                    if (helper[key].type === 'checkin') {
                        helper[key].checkInCount = o.count
                        helper[key].checkOutCount = 0
                        helper[key].installedCount = 0
                        r.push(helper[key]);
                    } else {
                        helper[key].checkInCount = o.checkedIn
                        helper[key].checkOutCount = o.count
                        helper[key].installedCount = o.installedCount
                        r.push(helper[key]);
                    }
                } else {
                    if (o.type !== 'checkin') {
                        helper[key].checkInCount += o.checkedIn
                        helper[key].checkOutCount += o.count
                        helper[key].installedCount += o.installedCount
                    } else {
                        helper[key].checkInCount += o.count
                    }
                }
                return r;
            }, []);
            await result.map(async x => {
                x.onHand = 0
                if (x.checkOutCount > 0 || x.checkInCount > 0 || x.installedCount > 0) {
                    x.onHand = x.checkOutCount - x.checkInCount - x.installedCount
                }
            })

            this.info = result
            this.isLoading = false

        },
        async getAllStock() {
            var movementItems = []
            await Api()
                .get('/checkoutItem/all' )
                .then(response => {
                    this.checkoutItems = response.data
                    movementItems = response.data
                    movementItems.forEach(function (element) {
                        element.type = "checkout";
                        if (element.deviceMakeModelId != null) {
                            element.name = element.ponMac
                        } else {
                            element.name = element.stockItem.name
                        }
                    })
                })
            await Api()
                .get('/checkinItem/all')
                .then(response => {
                    response.data.map(y => {
                        y.type = 'checkin'
                        if (y.deviceMakeModelId != null) {
                            y.name = y.ponMac
                        } else {
                            y.name = y.stockItem.name
                        }
                        movementItems.push(y)
                    })
                })
            let array = movementItems.sort((a, b) => (a.updatedAt > b.updatedAt) ? 1 : ((a.updatedAt < b.updatedAt) ? -1 : 0));
            this.movementItems = array
            await this.movementItems.map(x => {
                x.updatedAt = this.formatDate(x.updatedAt)
            })
            await this.movementItems.map(async x => {
                if (x.deviceMakeModelId != null) {
                    x.name = x.ponMac
                } else {
                    x.name = x.stockItem.name
                }
            })
            var helper = {}
            var result = this.movementItems.reduce(function (r, o) {
                var key = o.name + o.contactId;
                if (!helper[key]) {
                    helper[key] = Object.assign({}, o);
                    if (helper[key].type === 'checkin') {
                        helper[key].checkInCount = o.count
                        helper[key].checkOutCount = 0
                        helper[key].installedCount = 0
                        r.push(helper[key]);
                    } else {
                        helper[key].checkInCount = o.checkedIn
                        helper[key].checkOutCount = o.count
                        helper[key].installedCount = o.installedCount
                        r.push(helper[key]);
                    }
                } else {
                    if (o.type !== 'checkin') {
                        helper[key].checkInCount += o.checkedIn
                        helper[key].checkOutCount += o.count
                        helper[key].installedCount += o.installedCount
                    } else {
                        helper[key].checkInCount += o.count
                    }
                }
                return r;
            }, []);
            await result.map(async x => {
                x.onHand = 0
                if (x.checkOutCount > 0 || x.checkInCount > 0 || x.installedCount > 0) {
                    x.onHand = x.checkOutCount - x.checkInCount - x.installedCount
                }
            })

            this.info = result
            this.isLoading = false

        },
        fetchContacts() {
            Api().get('/checkoutItem/checkinItem/contacts').then(response => {
                this.contacts = response.data
            })
        },

        async groupByItem(contactIdChosen) {
            this.isLoading = true
            this.getStock(contactIdChosen)
        },
    }
}
</script>
